<template>
  <v-container
    ><v-row>
      <v-col sm="8" class="pb-0"
        ><h1>{{ formattedDate }}</h1></v-col
      >
      <v-col sm="4" class="pb-0">
        <v-img
          max-width="143"
          src="/img/confrans.png"
          class="float-right"
        ></v-img>
      </v-col>
    </v-row>
    <v-row
      ><v-col v-for="order in orders" :key="order.id" cols="4">
        <v-card>
          <v-card-title class="py-0" style="background-color: #e0e0e0"
            ><h6 style="width: 100%">
              <span>{{ order.name }}</span>
              <div class="float-right">
                <span>
                  <span>R</span>
                  <v-icon>mdi-crop-square</v-icon>
                </span>
                <span>K</span>
                <v-icon>mdi-crop-square</v-icon>
              </div>
            </h6></v-card-title
          ><v-card-text>
            <table dense>
              <tbody>
                <tr v-for="item in items[order.id]" :key="item.id">
                  <td>{{ item.amount }}</td>
                  <td>{{ item.product }}</td>
                  <td>{{ item.size }}</td>
                  <td>{{ item.pack }}</td>
                </tr>
              </tbody>
            </table>
            <v-divider v-if="order.note != ''"></v-divider>
            <p class="mb-0">{{ order.note }}</p>
          </v-card-text>
        </v-card></v-col
      ></v-row
    >
    <p style="page-break-before: always" v-if="loadImage"></p>
    <v-img
      src="/img/stocklijst.png"
      @load="load.stock = true"
      v-if="loadImage"
    ></v-img
  ></v-container>
</template>

<script>
import { firestore } from "firebase";
import moment from "moment";
export default {
  data() {
    return {
      orders: [],
      items: {},
      loadImage: false,
      load: {
        items: false,
        stock: false,
      },
    };
  },
  computed: {
    formattedDate() {
      return moment(this.$route.params.date, "YYYY-MM-DD")
        .lang("nl")
        .format("dddd D MMMM");
    },
  },
  mounted() {
    this.fetchOrders();
  },
  watch: {
    "load.items": "print",
    "load.stock": "print",
  },
  methods: {
    print() {
      if (this.load.items && this.load.stock) {
        setTimeout(() => {
          window.print();
        }, 500);
      }
    },
    async fetchOrders() {
      let orders = await firestore()
        .collection("Orders")
        .where("saleDate", "==", this.$route.params.date)
        .where("concept", "==", false)
        .get();
      let _self = this;
      orders.forEach((order) => {
        _self.items[order.id] = [];
        _self.orders.push({
          id: order.id,
          ...order.data(),
        });
      });
      this.fetchItems();
    },
    async fetchItems() {
      let s = await firestore().collection("App-Settings").doc("Orders").get();
      if (s.data().attachStockList) {
        this.loadImage = true;
      } else {
        this.load.stock = true;
      }
      let _self = this;
      for (var i = 0; i <= this.orders.length - 1; i++) {
        let items = await firestore()
          .collection(`Orders/` + _self.orders[i].id + "/items")
          .get();
        items.forEach((item) => {
          let d = item.data();
          d.size = d.size.substr(0, 2);
          _self.items[_self.orders[i].id].push({ id: item.id, ...d });
        });
        this.$forceUpdate();
      }
      this.load.items = true;
    },
  },
};
</script>

<style scoped>
tr {
  width: 100%;
  height: 25px;
  margin-bottom: 1px;
}
td {
  border-bottom: 1px solid gray;
}
tr td:nth-child(1) {
  margin-left: 10px;
  width: 10%;
}
tr td:nth-child(2) {
  width: 70%;
}
tr td:nth-child(3) {
  width: 10%;
}
tr td:nth-child(4) {
  width: 10%;
}
</style>